<template>
  <div class="image-container">
    <Loader :is-loading="isLoading" />
    <slot></slot>
    <img loading="lazy" ref="imageEl" :src="src" :alt="source" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import Loader from '@/components/Loader.vue'

const props = defineProps<{ source: string }>()
const src = ref('')
const isLoading = ref(false)
const imageEl = ref<HTMLImageElement | null>(null)

watch(() => props.source, (val) => loadImage(val))
onMounted(() => loadImage(props.source))

function loadImage(source: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    src.value = source
    isLoading.value = true

    const img = imageEl.value

    function loadEventListener() {
      img?.removeEventListener('load', loadEventListener)
      img?.removeEventListener('error', errorEventListener)
      isLoading.value = false
      resolve()
    }

    function errorEventListener() {
      img?.removeEventListener('load', loadEventListener)
      img?.removeEventListener('error', errorEventListener)
      isLoading.value = false
      reject('Image could not be loaded')
    }

    if (img) {
      img.addEventListener('load', loadEventListener)
      img.addEventListener('error', errorEventListener)
    }
  }).catch(() => {})
}

defineExpose({ loadImage })
</script>
